<template>
	<div class="media widthz">
		<div class="navGo flex ">
			<span @click="goHomg()">首页></span>
			<span>更多</span>
		</div>

		<section class="widthWhite">
			<div class="flex zhong float">
				<figure class="flex zhong more_fg">
					<img src="../../image/more.png" />
					<figcaption>{{newsTitle}}</figcaption>
				</figure>
				<article class="seach flex zhong ">
					<input type="text" v-model="KeyWord" placeholder="请输入新闻标题/摘要" />
					<div class="seach_btn flex zhong center">
						<img src="../../image/media-s.png" />
						<button type="button" v-on:click="GetList(1)">搜索</button>
					</div>
				</article>
			</div>
			<article class="home_mei_right">
				<ul>
					<li class="flex float " v-for="(item, index) in meiList" :key="index" @click="details(item.Id)">
						<div class="hmei_pic"><img :src="item.PictureStr" /></div>
						<hgroup>
							<h6>{{ item.Name }}</h6>
							<!-- <p>{{ item.Describle }}</p> -->
						</hgroup>
					</li>
				</ul>
			</article>

			<article class="flex zhong center page">
				<el-pagination background layout="prev, pager, next" @current-change="GetMore" :current-page="page" :page-size="10" :total="totle"></el-pagination>
			</article>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'media',
		data() {
			return {
				meiList: [],
				KeyWord: '',
				page: 1,
				totle: 0,
				newsTitle: '媒体报道'
			};
		},
		mounted() {
			this.GetList(1);
			this.GetProjectSet();
		},
		methods: {
			// 返回首页
			goHomg() {
				this.$router.push('/home');
			},
			// details() {
			//      this.$router.push('/fuWuxq');
			// },
			GetList: function(page) {
				var that = this;
				console.log(that.KeyWord);
				that.$api.HtppRequest(
					'WebsiteSet/GetHeadlines?size=10' + '&page=' + page + '&name=' + that.KeyWord,
					'GET', {},
					function(res) {
						console.log('获取首页图片');
						console.log(res);
						if (res.code === 0) {
							that.meiList = res.data;
							that.page = page;
						}
						that.GetNewsTitle();
					},
					function(res) {}
				);
			},
			GetMore: function(page) {
				var that = this;
				that.page = page;
			},
			details(id) {
				this.$router.push({
					path: '/headDetails',
					query: {
						Id: id
					}
				});
			},
			// 获取首页开启状态
			GetProjectSet: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetProjectSet',
					'GET', {},
					function(res) {
						console.log('获取首页开启状态');
						console.log(res);
						if (res.code === 0) {
							var list = res.data;
							for (var i = 0; i < list.length; i++) {
								if (list[i].type === 5) {
									that.newsTitle = list[i].Name;
								}
							}
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>
<style lang="scss" scoped>
	.page {
		margin-top: 40px;
	}

	.home_mei_right hgroup p {
		color: #666666;
		font-size: 14px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		overflow: hidden;
		margin-top: 10px;
	}

	.home_mei_right hgroup {
		overflow: hidden;
		width: calc(100% - 305px);
	}

	.home_mei_right hgroup h6 {
		padding-top: 20px;
		font-size: 16px;
		font-weight: normal;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.hmei_pic img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.hmei_pic {
		overflow: hidden;
		border-radius: 6px;
		width: 280px;
		height: 200px;
		background: url(../../image/nob.png) no-repeat center center;
		background-size: 100% 100%;
	}

	.home_mei_right ul li {
		width: 100%;
		cursor: pointer;
		margin-top: 40px;
	}

	.home_mei_right ul li:hover {
		opacity: 0.7;
	}

	.home_mei_right ul {
		overflow: hidden;
	}

	/* home_mei_right */

	/*media_top*/

	.seach input {
		font-size: 14px;
		color: #333;
		display: block;
		width: 100%;
		padding-left: 0.5em;
	}

	.seach_btn button {
		width: 100%;
		height: 100%;
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		cursor: pointer;
		opacity: 0;
	}

	.seach_btn img {
		display: block;
		width: 20px;
		height: 20px;
	}

	.seach_btn {
		overflow: hidden;
		width: 60px;
		height: 100%;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		background-color: #333;
		position: relative;
	}

	.seach {
		width: 400px;
		height: 40px;
		border-radius: 4px;
		border: solid 1px #333;
		overflow: hidden;
	}

	.more_fg img {
		display: block;
		width: 24px;
		height: 24px;
		margin-right: 10px;
	}

	.more_fg figcaption {
		font-size: 18px;
		color: #333;
		font-weight: bold;
	}
</style>
